import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import { addCart } from '@/services/http';
import { readCookie } from '@/tools/tools';
import { Action } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.dialogVisible = false;
    _this.dataList = [];
    _this.priceList = [];
    _this.selectprice = [];
    _this.quantity = 1;
    _this.productInfo = {};
    _this.imgFirst = '';
    _this.objData = {};
    _this.selectedSku = {
      id: 0,
      natureValue: ''
    }; // 当前选中的SKU
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "selectSku",
    value: function selectSku(sku) {
      this.selectedSku = sku;
      // 确保类型一致，都转为字符串比较
      var currentId = String(sku.id);
      this.selectprice = this.objData.pricelist.filter(function (item) {
        return String(item.natureIds) === currentId;
      });
      if (this.selectprice.length > 0 && this.selectprice[0].mallImage) {
        this.imgFirst = this.selectprice[0].mallImage.cdnFilePathH5;
        this.productInfo = this.selectprice[0];
      } else {
        this.imgFirst = this.objData.FilePathPcimg;
      }
    }
  }, {
    key: "handSku",
    value: function handSku(item) {
      var _this2 = this;
      this.quantity = 1;
      this.objData = item;
      this.selectedSku.id = item.selectarr[0].id;
      this.selectedSku.natureValue = item.selectarr[0].natureValue;
      this.productInfo = item.pricelist[0];
      this.imgFirst = item.FilePathPcimg;
      this.selectprice = this.objData.pricelist.filter(function (item) {
        return String(_this2.selectedSku.id) === item.natureIds;
      });
      this.dialogVisible = true;
    }
  }, {
    key: "handClick",
    value: function handClick() {
      var _this$selectprice$,
        _this3 = this;
      var anchor = readCookie('anchor');
      addCart({
        productPriceId: (_this$selectprice$ = this.selectprice[0]) === null || _this$selectprice$ === void 0 ? void 0 : _this$selectprice$.id,
        num: this.quantity,
        equip: anchor ? anchor.equip : '',
        version: anchor ? anchor.version : '',
        companyId: 1
      }).then(function (res) {
        if (res.data.code == 100) _this3.$message.success('加入购物车成功');
        _this3.dialogVisible = false;
        _this3.setCardNum();
        _this3.setWhiteStauts();
      });
    }
  }]);
}(Vue);
__decorate([Action('card/setCardNum')], default_1.prototype, "setCardNum", void 0);
__decorate([Action('white/setWhiteStauts')], default_1.prototype, "setWhiteStauts", void 0);
default_1 = __decorate([Component({
  name: 'SKU'
})], default_1);
export default default_1;